/* 2026-09-28 : ameliorations progressives du moteur collection commun. */
(() => {
  if (window.milauraCollectionControlsInitialized) return;
  window.milauraCollectionControlsInitialized = true;
  const updateNavigationTone = () => {
    const navigation = document.querySelector('[data-milaura-navigation]');
    const hero = document.querySelector('.milaura-collection-v2__hero');
    if (!navigation) return;
    const overHero = hero && hero.getBoundingClientRect().bottom > navigation.getBoundingClientRect().bottom;
    navigation.dataset.collectionHeroTone = overHero
      ? (window.matchMedia('(min-width: 750px)').matches ? hero.dataset.toneDesktop : hero.dataset.tone)
      : 'dark';
  };
  let navigationFrame = null;
  const scheduleNavigationTone = () => {
    if (navigationFrame !== null) return;
    navigationFrame = window.requestAnimationFrame(() => {
      navigationFrame = null;
      updateNavigationTone();
    });
  };
  window.addEventListener('scroll', scheduleNavigationTone, { passive: true });
  window.addEventListener('resize', scheduleNavigationTone);
  const initialize = (root) => {
    root.querySelectorAll('.milaura-collection-v2__controls').forEach((form) => {
      if (form.classList.contains('is-enhanced')) return;
      const select = form.querySelector('select[name="sort_by"]');
      if (select) select.addEventListener('change', () => form.requestSubmit());
      form.classList.add('is-enhanced');
    });
    root.querySelectorAll('[data-collection-marquee]').forEach((marquee) => {
      if (marquee.dataset.initialized) return;
      const button = marquee.querySelector('[data-marquee-toggle]');
      if (!button) return;
      marquee.dataset.initialized = 'true';
      marquee.classList.add('is-ready');
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = marquee.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Reprendre' : 'Pause';
        button.setAttribute('aria-label', paused ? 'Reprendre le bandeau défilant' : 'Mettre le bandeau en pause');
      });
    });
    root.querySelectorAll('[data-collection-information]').forEach((information) => {
      if (information.dataset.initialized) return;
      const tablist = information.querySelector('[data-info-tabs]');
      const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
      const panels = Array.from(information.querySelectorAll('[data-info-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      information.dataset.initialized = 'true';
      tablist.hidden = false;
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
          panels[i].tabIndex = 0;
          panels[i].querySelector('[data-info-title]').hidden = true;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      select(0);
    });
    root.querySelectorAll('[data-grid-controls]').forEach((controls) => {
      if (controls.dataset.initialized) return;
      const collection = controls.closest('[data-collection-v2]') || document.querySelector('.milaura-collection-grid');
      if (!collection) return;
      controls.dataset.initialized = 'true';
      controls.hidden = false;
      const applyView = (view) => {
        collection.dataset.gridView = view;
        controls.querySelectorAll('[data-grid-view]').forEach((choice) => {
          choice.setAttribute('aria-pressed', String(choice.dataset.gridView === view));
        });
      };
      try { if (sessionStorage.getItem('milauraCollectionView') === 'large') applyView('large'); } catch (_) { /* Storage is optional. */ }
      controls.querySelectorAll('[data-grid-view]').forEach((button) => {
        button.addEventListener('click', () => {
          applyView(button.dataset.gridView);
          try { sessionStorage.setItem('milauraCollectionView', button.dataset.gridView); } catch (_) { /* Storage is optional. */ }
        });
      });
    });
  };
  initialize(document);
  updateNavigationTone();
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    updateNavigationTone();
  });
})();
